import * as React from "react";

const SvgBack = React.forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 2350"
      {...props}
			ref={ref}
    >
      <style>
        {
          ".back_svg__black-star{fill:none;stroke:#12122e;stroke-width:6.3px;stroke-linecap:round;stroke-linejoin:round}.back_svg__circle{fill:url(#back_svg__linear-gradient)}"
        }
      </style>
      <defs>
        <linearGradient
          id="back_svg__linear-gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#76c6f5" />
          <stop offset="100%" stopColor="#00fcac" />
        </linearGradient>
      </defs>
      <g id="back_svg__back_animated" data-name="back animated">
        <path
          id="back_svg__white-blob-2"
          fill="#fff"
          stroke="#000"
          strokeWidth={3.15}
          className="back_svg__cls-1"
          d="M1974 609.71c-.08-1.15-.18-2.29-.29-3.43-.45-5-1.13-9.9-2-14.67-.2-1.14-.42-2.29-.65-3.43-.93-4.79-2.1-9.54-3.47-14.17-.32-1.13-.66-2.26-1-3.38-1.4-4.63-3-9.2-4.83-13.62-.46-1.14-.93-2.29-1.42-3.42-1.83-4.4-3.91-8.77-6.18-13a191.6 191.6 0 00-2-3.73c-2.26-4.13-4.72-8.18-7.5-12.29s-5.6-8.07-8.63-11.82q-1.5-1.87-3-3.71c-3.1-3.74-6.41-7.35-10.07-11-3.46-3.5-7.15-6.88-11-10.09s-7.87-6.36-11.95-9.18a150.73 150.73 0 00-13-8.29c-1.62-.93-3.28-1.85-5-2.74a152.37 152.37 0 00-14.24-6.73 148.37 148.37 0 00-15-5.43 150.29 150.29 0 00-14.93-3.92c-.93-.2-1.89-.39-2.88-.58-4.63-.94-9.46-1.68-14.37-2.2-4.35-.5-8.56-.8-12.75-.93h-.81l-5.24-.09c-4.44 0-9 .16-13.52.54-.92.07-1.84.14-2.76.23-5 .44-9.83 1.1-14.53 2-1 .17-2 .36-3 .55s-2.21.45-3.28.68c-4.65 1-9.26 2.17-14 3.64-.83.25-1.68.52-2.55.8a156.05 156.05 0 00-13.68 5c-1 .4-1.94.81-2.94 1.25-4.3 1.83-8.51 3.87-12.81 6.19-.9.48-1.8 1-2.72 1.49-4 2.19-8 4.58-11.93 7.25-.91.6-1.8 1.2-2.69 1.82-3.69 2.5-7.34 5.22-10.89 8.1-.82.66-1.64 1.34-2.45 2-3.49 2.86-6.9 5.92-10.15 9.11-.9.87-1.78 1.75-2.66 2.64-3.28 3.26-6.45 6.71-9.46 10.3-1.28 1.5-2.56 3.05-3.86 4.7-3 3.72-5.89 7.64-8.71 11.91-2.74 4-5.31 8.17-7.66 12.43a149.5 149.5 0 00-6.85 13.45c-1 2.11-1.9 4.25-2.78 6.4-2 4.62-3.7 9.46-5.23 14.42a150 150 0 00-4 15c-.29 1.25-.5 2.46-.75 3.69l-1.39.48c-2.67.89-5.36 1.87-8 2.93q-2.33.84-4.53 1.74c-1.64.61-3.25 1.25-4.82 1.9s-3.16 1.26-4.71 1.93-3.14 1.29-4.69 2-3.17 1.34-4.77 2.07c-1.45.62-2.91 1.28-4.4 2-2.58 1.12-5.13 2.31-7.61 3.56-1.07.5-2.11 1-3.13 1.52-.45-1.22-.91-2.43-1.39-3.64a219.75 219.75 0 00-18.68-38 225.54 225.54 0 00-24.92-32.94 229.34 229.34 0 00-29.79-27.48 227.74 227.74 0 00-34.59-22 224.28 224.28 0 00-55.76-19.83c-4.73-1.09-9.48-1.95-14.21-2.57-4.49-.73-9.07-1.26-13.68-1.59a144.93 144.93 0 00-14.59-.86h-.08c-1.5-.07-3.21-.12-5-.14-2.7 0-5.19.05-7.36.14-4.58.05-9.21.31-14 .81-4.26.28-8.47.73-12.58 1.34s-8.33 1.18-12.52 2c-4.12.7-8.17 1.54-12.11 2.54s-7.73 1.88-11.58 3.06q-6.24 1.67-12.2 3.8c-3.53 1.14-7 2.4-10.44 3.78-2.41.91-4.81 1.88-7.18 2.91q-4 1.62-7.88 3.43c-3.21 1.41-6.41 3-9.58 4.62-2.44 1.19-4.87 2.47-7.26 3.8s-4.91 2.65-7.27 4.05c-3 1.67-6 3.47-8.87 5.37-2.28 1.4-4.54 2.87-6.75 4.4s-4.52 3-6.69 4.59c-2.78 1.91-5.51 3.93-8.17 6q-3.2 2.4-6.3 5c-3.2 2.52-6.3 5.16-9.27 7.91q-5.64 4.73-10.8 10a155 155 0 00-11 11.23q-5.18 5.31-9.81 11.09c-1.24 1.41-2.46 2.85-3.66 4.3l-.37.32-.09-.1c-.6-.69-1.22-1.37-1.83-2.05h0c-.44-.6-.87-1.19-1.31-1.77l-.16-.23-.69-1.14-.64-1.1-.41-.87c-.27-.68-.53-1.37-.81-2s-.5-1.61-.76-2.41c-.14-.57-.28-1.15-.43-1.72-.17-1-.35-2-.54-3-.08-.79-.17-1.57-.26-2.35 0-1-.1-2.05-.16-3.08v-2.22-1.49c.09-1.09.17-2.18.23-3.26.12-.88.24-1.76.34-2.64.25-1.19.49-2.39.71-3.59.18-.71.36-1.42.52-2.14.36-1.1.7-2.19 1-3.3.23-.6.45-1.2.67-1.81.42-1 .84-1.94 1.24-2.91.26-.51.51-1 .75-1.51l.48-.84c.11-.11.21-.22.31-.34 2.73-2.76 5.36-5.64 7.88-8.61a154.31 154.31 0 0010-11.87 151.82 151.82 0 0035.08-95.9c.65-83.86-67.05-152.61-150.9-153.27h-1.21a151.29 151.29 0 00-80.38 22.93A151.72 151.72 0 00875 242.07c-4.47 0-8.93.13-13.37.48-2.72.18-5.43.43-8.11.75a175.12 175.12 0 00-32.73 7 175.68 175.68 0 00-43.36 20.64A180.32 180.32 0 00753.2 290a178.2 178.2 0 00-5 4.88 177.18 177.18 0 00-28.2 37.54 150.87 150.87 0 00-12 24.22 151.2 151.2 0 00-13.47-7.38l.27-.5a150.72 150.72 0 0012.89-24.66 150.54 150.54 0 009.56-23.89 150.83 150.83 0 007.52-27.56 151.87 151.87 0 004.79-31.27 149.27 149.27 0 001.07-16.67c0-4.56-.14-9.1-.53-13.71a151.77 151.77 0 00-4-32.77 150.55 150.55 0 00-9.1-32.87 151.07 151.07 0 00-14.33-31.55A150.84 150.84 0 00682 83a151.28 151.28 0 00-24.84-26.17 150.75 150.75 0 00-26.77-20.48 150.65 150.65 0 00-29.6-16.27A151 151 0 00571.27 9a151.19 151.19 0 00-29.9-7 151.74 151.74 0 00-29-3.06h-.22c-3.8-.33-7.55-.5-11.29-.53A150.66 150.66 0 00483-.64a151.9 151.9 0 00-29.41 3.91 151.32 151.32 0 00-28.18 7.19 151.61 151.61 0 00-28.71 11.22 151.17 151.17 0 00-27.85 15.26 151.64 151.64 0 00-22.58 16.21 150.59 150.59 0 00-19.87 17.72 152.84 152.84 0 00-17.53 19.06 151.06 151.06 0 00-15.43 20.42 152.06 152.06 0 00-13.06 20.77 150.14 150.14 0 00-10.45 20.29 149.52 149.52 0 00-6.41 14.21 152.07 152.07 0 00-19 1.23 150.93 150.93 0 00-23.3 2.7A152.07 152.07 0 0084.89 319.61c-.65 83.86 67.05 152.61 150.91 153.26a152.18 152.18 0 0030.34-2.82l2.52-.29a146.7 146.7 0 001.84 6.84q.94 5 2.22 9.93c-1.52-.06-3-.1-4.53-.11a152.09 152.09 0 00-153.27 150.9c-.6 76.94 57.63 142.75 133.49 152.1 2.14.33 4.28.62 6.4.86l3.1.38c1.09.14 2.15.26 3.2.37s2.12.25 3.19.35 2.14.24 3.25.34 2.31.24 3.32.32l2.9.27c2.1.21 4.23.38 6.37.51 3.19.3 6.32.51 9.47.61 2.86.23 5.67.38 8.48.45.93 0 1.94.09 3.05.12s2.05.08 3.21.1c1 0 2.1.08 3.24.09.91 0 1.87 0 2.87.06h7.09c.91 0 1.89.06 2.92.06 2.58 0 5.12 0 7.7-.13 2.14 0 4 0 5.59-.11l2.69-.08c2.84-.05 5.7-.17 8.54-.38l1.73-.08c.28 1.13.57 2.26.88 3.38q.93 4.44 2.12 8.81.93 4.44 2.12 8.81 1.08 5.15 2.5 10.17c.77 4.13 1.72 8.24 2.84 12.3q1 5.79 2.5 11.5.87 5.49 2.15 10.89.72 5.28 1.81 10.47c.36 3.12.81 6.23 1.36 9.31.24 2.91.58 5.82 1 8.72q.19 4.14.63 8.27c0 2.27.1 4.54.23 6.83-.05 1.43-.08 2.84-.1 4.25v1.9c-.13 1.46-.24 2.92-.32 4.37-.09.65-.17 1.3-.24 2h0c-1.29.24-2.58.5-3.86.78q-2.61.24-5.22.57c-2 0-4 0-6 .12q-3-.29-6.08-.42-3.14-.56-6.27-1c-1.24-.32-2.48-.63-3.73-.93s-2.67-.75-4-1.1l-3-.9-2.66-.89c-1.4-.52-2.83-1-4.27-1.52s-2.58-1-3.87-1.5-2.58-1.08-3.87-1.59c-.91-.41-1.82-.81-2.74-1.2-1.55-.74-3.12-1.46-4.73-2.17q-2.07-1.05-4.2-2c-1.52-.81-3-1.58-4.58-2.33s-3.22-1.74-4.86-2.57q-3.66-2.19-7.43-4.18-3.37-2.1-6.85-4-3.44-2.26-7-4.32-3.59-2.46-7.3-4.7-4-2.82-8.11-5.38-3.94-2.88-8.08-5.51-4.06-3-8.31-5.8-4.17-3.18-8.53-6.06-4.28-3.3-8.74-6.28-4.35-3.39-8.9-6.45A152.06 152.06 0 1035 1090.45q4.64 3.63 9.49 6.87 4.81 3.77 9.88 7.1 4.93 3.81 10.13 7.19c3.38 2.57 6.87 5 10.44 7.27q5.2 3.88 10.74 7.33 5.36 3.9 11 7.34c3.84 2.73 7.84 5.29 12 7.67 4 2.73 8.08 5.26 12.29 7.6q6.21 4.1 12.75 7.53c4 2.48 8 4.78 12.2 6.88q5.72 3.4 11.74 6.31 4.4 2.42 8.93 4.54 4.37 2.3 8.88 4.31 4.37 2.2 8.91 4.14 5.4 2.63 11 4.83 5 2.25 10.05 4.12 4.75 2 9.64 3.69 4.79 1.92 9.73 3.51 5.67 2.13 11.56 3.83 5.64 2 11.38 3.43 5 1.56 10.18 2.78a153.13 153.13 0 0021.82 4.61 150.76 150.76 0 0031.61 4.9 150.24 150.24 0 0025 2.28c2.3 0 4.63 0 7-.11 4.09.37 8.18.56 12.26.6a149 149 0 0020-1.19h.27a150.92 150.92 0 0032.35-3.51 149.53 149.53 0 0033.49-6.88 153.11 153.11 0 0032.47-10.14 153.17 153.17 0 0032.48-14.08 152.66 152.66 0 0032.08-18.62 152.89 152.89 0 0030.31-23.23 152.61 152.61 0 0027.79-27.9 228.31 228.31 0 0026.49-34.91q3.93-6 7.31-12.27a152.65 152.65 0 007.29-13.81q3.31-6.33 6-13c2.09-4.48 4-9.08 5.6-13.74 1.67-4.15 3.17-8.4 4.49-12.7 1.67-4.68 3.12-9.46 4.33-14.29l.75-2.58q5-1.32 9.81-2.95a151.6 151.6 0 0012.09-3.86q5.8-1.75 11.47-4 5.78-1.87 11.38-4.21 6-2.07 11.75-4.63c4.07-1.54 8.09-3.25 12-5.14q5.61-2.29 11-5 5.57-2.42 10.93-5.26 5.58-2.55 10.92-5.54 6-2.91 11.76-6.37 5.37-2.81 10.5-6 5.32-2.91 10.4-6.26c3.56-2.05 7-4.25 10.42-6.57Q810 928.51 816 924a148.85 148.85 0 0014.27-10.22 153 153 0 0013.68-10.49 153.86 153.86 0 0012.77-10.45 152.23 152.23 0 0013.47-11.78 151.77 151.77 0 0012.55-11.76 152.47 152.47 0 0011.73-11.71 150.24 150.24 0 0012.5-13.35 151.49 151.49 0 0011.19-12.84 152.37 152.37 0 0010.59-12.94 152.71 152.71 0 0011.41-15q3.14-4 6-8.13l1.65 1.48q4.71 4.47 9.83 8.57a156.89 156.89 0 0012.58 10.13c3.94 3.22 8 6.25 12.26 9a150.25 150.25 0 0013.5 9q6.24 4.23 12.85 7.82a149.77 149.77 0 0014.18 7.78q6.52 3.63 13.39 6.61a151.86 151.86 0 0014.8 6.53c4.52 2 9.16 3.82 13.88 5.4a336.46 336.46 0 0029.78 9.45q3.89 1.17 7.82 2.13c.21.53.43 1.06.64 1.58.63 1.62 1.29 3.22 2 4.8s1.38 3.29 2.12 5 1.44 3.28 2.07 4.61q2 4.56 4.36 9.07 1.44 2.91 3 5.75c1.91 3.83 3.92 7.5 6.08 11.05q2.37 4.24 5 8.36 3.1 5.2 6.68 10.24c2 3.15 4.18 6.2 6.4 9.12 2 2.86 4.15 5.67 6.39 8.42 2.42 3.23 5 6.37 7.64 9.39 2.19 2.69 4.47 5.29 6.8 7.79q3.65 4.17 7.68 8.17 4.14 4.45 8.54 8.5c2.27 2.24 4.61 4.42 7 6.51q5 4.71 10.53 9 4.95 4.27 10.26 8.11 5.37 4.26 11.14 8c3.83 2.79 7.81 5.4 11.89 7.82 3.59 2.36 7.29 4.58 11.08 6.63q6.54 3.94 13.46 7.24 5.41 2.89 11.08 5.34a149.61 149.61 0 0014.91 6.35c3.8 1.59 7.67 3 11.58 4.3a151.33 151.33 0 0015.69 5q6.09 1.89 12.34 3.27c3.93 1 8 2 12.07 2.7l.55.12.18.75c.78 3.65 1.72 7.31 2.79 11q.9 3.36 2 6.65c.67 2.3 1.41 4.6 2.19 6.87q1.77 5.51 4 11c.83 2.18 1.72 4.36 2.66 6.51 1.54 3.79 3.17 7.4 4.94 10.91q1.7 3.55 3.57 7c1.2 2.34 2.46 4.65 3.78 6.91 1.94 3.52 4 7 6.29 10.4 1.51 2.42 3.1 4.8 4.75 7.12 2.34 3.48 4.84 6.88 7.46 10.14 1.81 2.38 3.71 4.72 5.66 7 2.64 3.21 5.4 6.32 8.26 9.28 2 2.15 4 4.25 6.15 6.3 2.91 2.94 5.92 5.76 9 8.42q3.19 2.88 6.56 5.59c3.2 2.72 6.4 5.23 9.68 7.58q3.45 2.6 7.09 5c2.37 1.67 4.79 3.27 7.23 4.79 3.37 2.19 6.88 4.27 10.58 6.27 2.37 1.36 4.78 2.66 7.21 3.89 3.54 1.9 7.21 3.67 11 5.3 2.42 1.13 4.9 2.19 7.39 3.2 3.82 1.63 7.68 3.11 11.56 4.41 2.5.9 5 1.75 7.61 2.52 4.12 1.36 8.14 2.51 12.16 3.48 2.69.7 5.42 1.34 8.16 1.9s5.46 1.17 8.21 1.64c4.12.8 8.36 1.43 12.66 1.9 2.67.35 5.37.64 8.08.85 4.36.46 8.6.72 12.95.8 1.4.07 3.05.13 4.81.14h4.25c4.43 0 8.71-.16 13.21-.54q4.13-.24 8.22-.71c4.41-.38 8.66-.94 12.85-1.67 2.82-.43 5.64-.94 8.43-1.53s5.62-1.12 8.38-1.8c4.06-.9 8.11-2 12.25-3.27 2.66-.75 5.31-1.58 7.91-2.47 3.88-1.24 7.75-2.65 11.57-4.21 2.59-1 5.16-2 7.68-3.18 3.78-1.57 7.48-3.29 11.07-5.14q3.73-1.82 7.37-3.83c3.7-1.94 7.2-3.94 10.57-6.07 2.41-1.44 4.79-3 7.14-4.56s4.71-3.13 7-4.78c3.33-2.3 6.57-4.76 9.81-7.41 2.2-1.72 4.36-3.5 6.45-5.33 3.12-2.59 6.16-5.33 9.09-8.2q3.13-2.92 6.11-6c2.92-2.9 5.73-5.94 8.4-9.07q2.91-3.26 5.63-6.67c2.66-3.19 5.21-6.5 7.59-9.87a152.16 152.16 0 00-84-237.72q2.4-2.64 4.7-5.4l.63-.67c.47-.47.91-.93 1.33-1.37l1.29-1.28c.44-.43.89-.86 1.32-1.3l1.33-1.25 1.35-1.25c.63-.55 1.35-1.2 2.14-1.93.64-.55 1.22-1.07 1.75-1.54s1-.84 1.46-1.24l1.42-1.18 1.37-1.11c.47-.36 1-.75 1.47-1.16l1.39-1.06c.64-.46 1.37-1 2.18-1.62s1.4-1 2-1.45l1.48-1 1.48-1 1.4-.92 1.51-1 1.48-.93c.66-.39 1.41-.84 2.23-1.35s1.47-.86 2.1-1.23l1.52-.86 1.49-.82 1.49-.79 1.48-.76 1.55-.77c.69-.32 1.48-.69 2.35-1.12l2.05-.94 1.53-.68 1.51-.64 1.54-.63 1.45-.56 2-.73 2.5-.88 1.56-.53 1.48-.48a152.31 152.31 0 0085.06-64.84c65.18-2.83 120.8-47.46 139.09-108.44 2.28-4.13 4.35-8.33 6.19-12.54a149.28 149.28 0 005.7-14.63c.58-1.71 1.13-3.44 1.65-5.16a150.36 150.36 0 003.82-15 155 155 0 002.47-15.55c.58-4.79.93-9.4 1.06-14 .06-1.33.1-2.65.11-4v-1.23c-.12-4.81-.31-9.63-.72-14.43z"
        />
        <g id="back_svg__dot-i">
          <circle
            className="back_svg__circle"
            cx={1776.09}
            cy={574.91}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1778.19}
            cy={575.23}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1786.63}
            cy={576.73}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1794.71}
            cy={578.58}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1803.15}
            cy={581.14}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1810.88}
            cy={584.32}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1819.19}
            cy={589.12}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1826.75}
            cy={595.63}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1831.7}
            cy={602.08}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1834.48}
            cy={607.52}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1836.52}
            cy={613.85}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1837.66}
            cy={622.07}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1837.23}
            cy={630.36}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1834.68}
            cy={639.93}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1829.95}
            cy={648.59}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1824.97}
            cy={654.16}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1819.72}
            cy={658.23}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1813.12}
            cy={661.72}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1805.19}
            cy={664.21}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1796.67}
            cy={665.18}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1787.38}
            cy={664.3}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1778.53}
            cy={661.28}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1772.39}
            cy={657.54}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1767.05}
            cy={652.74}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1762.13}
            cy={646.4}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1758.35}
            cy={639}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1755.98}
            cy={630.77}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1755.32}
            cy={622}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1756.57}
            cy={613.55}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1759.31}
            cy={606.33}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1763.39}
            cy={599.75}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1768.99}
            cy={593.64}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1775.66}
            cy={588.67}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1783.11}
            cy={585.07}
            r={41.25}
          />
          <circle
            className="back_svg__circle"
            cx={1791.11}
            cy={583.03}
            r={41.25}
          />
        </g>
        <g id="back_svg__i">
          <circle
            className="back_svg__circle"
            cx={1670.13}
            cy={735.84}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1665.96}
            cy={737.15}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1657.69}
            cy={739.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1649.52}
            cy={743.04}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1641.46}
            cy={746.37}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1633.51}
            cy={749.95}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1625.68}
            cy={753.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1617.98}
            cy={757.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1610.4}
            cy={762.09}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1602.95}
            cy={766.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1595.63}
            cy={771.32}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1588.45}
            cy={776.26}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1581.42}
            cy={781.41}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1574.53}
            cy={786.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1567.75}
            cy={792.35}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1561.21}
            cy={798.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1554.79}
            cy={803.99}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1548.54}
            cy={810.1}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1542.46}
            cy={816.39}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1536.55}
            cy={822.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1530.83}
            cy={829.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1525.3}
            cy={836.25}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1519.96}
            cy={843.18}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1514.83}
            cy={850.23}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1509.88}
            cy={857.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1505.14}
            cy={864.82}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1500.62}
            cy={872.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1496.32}
            cy={879.9}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1492.24}
            cy={887.61}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1488.38}
            cy={895.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1484.76}
            cy={903.35}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1481.37}
            cy={911.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1478.22}
            cy={919.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1473.42}
            cy={933.48}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1469.36}
            cy={947.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1466.04}
            cy={962.1}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1463.5}
            cy={976.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1462.39}
            cy={985.37}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1462.08}
            cy={988.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1461.82}
            cy={990.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1461.59}
            cy={993.36}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1461.4}
            cy={995.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1461}
            cy={1004.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1461.03}
            cy={1013.82}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1461.54}
            cy={1022.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1462.59}
            cy={1031.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1464.2}
            cy={1039.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1466.39}
            cy={1048.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1469.24}
            cy={1055.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1472.79}
            cy={1063.49}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1477.1}
            cy={1070.75}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1482.43}
            cy={1077.84}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1488.52}
            cy={1084.28}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1495.28}
            cy={1090.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1502.62}
            cy={1095.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1510.34}
            cy={1099.15}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1518.35}
            cy={1102.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1526.65}
            cy={1104.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1535.16}
            cy={1106.39}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1543.79}
            cy={1106.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1552.57}
            cy={1106.56}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1561.25}
            cy={1105.18}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1569.74}
            cy={1102.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1577.93}
            cy={1099.65}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1585.72}
            cy={1095.63}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1593.01}
            cy={1090.84}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1599.76}
            cy={1085.31}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1605.87}
            cy={1079.09}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1611.25}
            cy={1072.23}
            r={49.78}
          />
        </g>
        <g id="back_svg__r">
          <circle
            className="back_svg__circle"
            cx={525.87}
            cy={867.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={526.5}
            cy={866.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={536.55}
            cy={866.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={546.58}
            cy={865.14}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={556.56}
            cy={863.79}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={566.5}
            cy={862.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={576.39}
            cy={860.26}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={586.23}
            cy={858.08}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={596} cy={855.63} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={605.7}
            cy={852.92}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={615.32}
            cy={849.94}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={624.87}
            cy={846.7}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={634.32}
            cy={843.21}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={643.68}
            cy={839.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={655.73}
            cy={834.21}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={670.33}
            cy={827.15}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={684.63}
            cy={819.49}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={698.58}
            cy={811.22}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={712.17}
            cy={802.36}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={725.36}
            cy={792.94}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={738.13}
            cy={782.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={750.46}
            cy={772.44}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={762.32}
            cy={761.39}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={773.67}
            cy={749.83}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={784.5}
            cy={737.78}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={794.77}
            cy={725.24}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={804.46}
            cy={712.24}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={807.17}
            cy={708.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={809.39}
            cy={705.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={811.58}
            cy={701.82}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={813.73}
            cy={698.51}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={815.84}
            cy={695.17}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={817.92}
            cy={691.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={819.96}
            cy={688.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={821.96}
            cy={685.03}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={823.92}
            cy={681.61}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={825.84}
            cy={678.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={827.73}
            cy={674.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={829.57}
            cy={671.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={832.42}
            cy={665.65}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={836.81}
            cy={656.58}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={840.95}
            cy={647.39}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={844.83}
            cy={638.09}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={848.47}
            cy={628.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={851.85}
            cy={619.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={854.97}
            cy={609.61}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={857.84}
            cy={599.95}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={860.45}
            cy={590.21}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={862.8}
            cy={580.4}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={864.89}
            cy={570.54}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={866.72}
            cy={560.62}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={868.28}
            cy={550.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={869.78}
            cy={538.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={870.95}
            cy={526.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={871.73}
            cy={514.44}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={872.1}
            cy={502.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={872.08}
            cy={489.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={871.65}
            cy={477.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={870.82}
            cy={465.45}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={869.59}
            cy={453.26}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={867.94}
            cy={441.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={865.89}
            cy={429.03}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={863.42}
            cy={417.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={860.54}
            cy={405.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={857.43}
            cy={396.24}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={854.78}
            cy={396.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={852.24}
            cy={396.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={849.83}
            cy={397.73}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={847.54}
            cy={398.74}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={845.37}
            cy={399.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={843.34}
            cy={401.44}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={841.44}
            cy={403.09}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={839.68}
            cy={404.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={838.07}
            cy={406.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={836.6}
            cy={409.08}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={835.28}
            cy={411.37}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={834.12}
            cy={413.77}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={832.72}
            cy={417.41}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={831.54}
            cy={421.77}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={830.83}
            cy={426.26}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={830.61}
            cy={430.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={830.89}
            cy={435.35}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={831.68}
            cy={439.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={833.02}
            cy={444.12}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={834.91}
            cy={448.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={837.33}
            cy={451.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={840.05}
            cy={455.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={843.04}
            cy={458.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={846.28}
            cy={461.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={850.53}
            cy={464.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={861.24}
            cy={469.65}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={872.99}
            cy={473.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={885.32}
            cy={475.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={897.75}
            cy={475.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={909.97}
            cy={475.32}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={922.1}
            cy={473.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={934.1}
            cy={471.59}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={945.9}
            cy={468.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={957.47}
            cy={464.53}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={968.75}
            cy={459.82}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={979.69}
            cy={454.36}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={990.22}
            cy={448.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={996.74}
            cy={443.83}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1000.32}
            cy={441.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1003.83}
            cy={438.62}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1007.28}
            cy={435.88}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1010.66}
            cy={433.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1013.96}
            cy={430.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1017.2}
            cy={427.17}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1020.35}
            cy={424.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1023.42}
            cy={420.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1026.42}
            cy={417.73}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1029.32}
            cy={414.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1032.15}
            cy={411.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1034.88}
            cy={407.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1027.42}
            cy={415.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1020.44}
            cy={422.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1013.95}
            cy={431.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1007.96}
            cy={439.8}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1002.45}
            cy={448.74}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={997.45}
            cy={457.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={992.95}
            cy={467.48}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={988.96}
            cy={477.22}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={985.49}
            cy={487.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={982.53}
            cy={497.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={980.1}
            cy={507.53}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={978.19}
            cy={517.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={976.85}
            cy={528.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={976.03}
            cy={537.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={975.69}
            cy={547.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={975.82}
            cy={557.48}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={976.42}
            cy={567.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={977.51}
            cy={577.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={979.08}
            cy={586.67}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={981.14}
            cy={596.24}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={983.68}
            cy={605.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={986.73}
            cy={614.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={990.27}
            cy={624.1}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={994.31}
            cy={633.03}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={998.86}
            cy={641.74}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1000.45}
            cy={644.52}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1001.6}
            cy={646.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1002.78}
            cy={648.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1003.98}
            cy={650.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1005.2}
            cy={652.18}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1006.45}
            cy={654.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1007.72}
            cy={655.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1009.01}
            cy={657.75}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1010.32}
            cy={659.57}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1011.66}
            cy={661.37}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1013.02}
            cy={663.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1014.4}
            cy={664.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1016.55}
            cy={667.59}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1020.44}
            cy={672.17}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1024.48}
            cy={676.61}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1028.67}
            cy={680.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1032.98}
            cy={685.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1037.43}
            cy={689.15}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1042.01}
            cy={693.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1046.7}
            cy={696.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1051.52}
            cy={700.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1056.44}
            cy={703.9}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1061.46}
            cy={707.23}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1066.59}
            cy={710.4}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1071.8}
            cy={713.42}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1077.12}
            cy={716.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1082.53}
            cy={719.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1088.01}
            cy={721.57}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1093.57}
            cy={723.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1099.19}
            cy={726.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1104.88}
            cy={728.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1110.63}
            cy={730.17}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1116.42}
            cy={731.9}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1122.27}
            cy={733.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1128.15}
            cy={734.84}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1134.07}
            cy={736.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1140.02}
            cy={737.07}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1145.99}
            cy={737.92}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1151.97}
            cy={738.58}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1157.97}
            cy={739.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1163.97}
            cy={739.35}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1169.98}
            cy={739.45}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1175.99}
            cy={739.36}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1181.99}
            cy={739.08}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1187.97}
            cy={738.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1193.94}
            cy={737.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1199.89}
            cy={737.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1205.81}
            cy={735.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1211.7}
            cy={734.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1217.55}
            cy={733.21}
            r={49.78}
          />
        </g>
        <g id="back_svg__e">
          <circle
            className="back_svg__circle"
            cx={1233.56}
            cy={689.58}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1239.09}
            cy={694.13}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1244.66}
            cy={698.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1250.3}
            cy={703.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1255.99}
            cy={707.64}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1261.75}
            cy={711.99}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1267.59}
            cy={716.22}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1273.52}
            cy={720.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1279.53}
            cy={724.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1285.24}
            cy={727.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1290.43}
            cy={730.59}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1295.29}
            cy={733.13}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1300.21}
            cy={735.5}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1305.21}
            cy={737.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1310.28}
            cy={739.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1315.43}
            cy={741.48}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1320.65}
            cy={743.04}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1325.96}
            cy={744.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1331.36}
            cy={745.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1340.12}
            cy={746.52}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1349.03}
            cy={746.67}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1357.95}
            cy={745.94}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1366.77}
            cy={744.34}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1375.37}
            cy={741.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1383.61}
            cy={738.65}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1391.38}
            cy={734.61}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1398.55}
            cy={729.79}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1404.31}
            cy={724.9}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1409.53}
            cy={719.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1413.47}
            cy={713.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1416.74}
            cy={708.1}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1419.3}
            cy={701.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1421.07}
            cy={695.22}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1421.95}
            cy={688.37}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1421.93}
            cy={681.57}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1421.06}
            cy={674.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1419.25}
            cy={667.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1416.53}
            cy={660.92}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1412.76}
            cy={653.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1408.16}
            cy={647.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1402.83}
            cy={641.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1396.84}
            cy={635.67}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1390.29}
            cy={630.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1383.25}
            cy={626.7}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1375.83}
            cy={623.41}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1368.09}
            cy={621.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1362.08}
            cy={619.8}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1356.03}
            cy={619.04}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1349.97}
            cy={618.71}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1343.9}
            cy={618.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1337.84}
            cy={619.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1331.81}
            cy={620.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1325.82}
            cy={621.44}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1319.89}
            cy={623.04}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1313.66}
            cy={625.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1309.32}
            cy={626.79}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1304.67}
            cy={628.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1300.11}
            cy={631.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1295.63}
            cy={633.4}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1291.24}
            cy={635.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1286.96}
            cy={638.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1282.78}
            cy={641.56}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1278.73}
            cy={644.59}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1274.8}
            cy={647.74}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1267.92}
            cy={653.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1261.44}
            cy={660.39}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1255.38}
            cy={667.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1249.74}
            cy={674.55}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1244.52}
            cy={682.12}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1239.75}
            cy={689.99}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1235.43}
            cy={698.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1231.57}
            cy={706.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1228.18}
            cy={715.04}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1224.93}
            cy={724.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1222.3}
            cy={735.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1220.31}
            cy={745.24}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1218.97}
            cy={755.56}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1218.3}
            cy={765.94}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1218.31}
            cy={776.33}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1219.02}
            cy={786.7}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1220.43}
            cy={797}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1222.57}
            cy={807.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1223.52}
            cy={810.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1224.57}
            cy={814.48}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1225.7}
            cy={818.07}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1226.93}
            cy={821.63}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1228.25}
            cy={825.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1229.65}
            cy={828.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1231.14}
            cy={832.12}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1232.72}
            cy={835.54}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1234.38}
            cy={838.93}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1237.71}
            cy={845.17}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1241.32}
            cy={851.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1245.2}
            cy={857.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1249.34}
            cy={862.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1253.72}
            cy={868.55}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1258.34}
            cy={873.94}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1263.19}
            cy={879.12}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1268.25}
            cy={884.1}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1273.52}
            cy={888.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1280.3}
            cy={894.4}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1287.36}
            cy={899.58}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1294.67}
            cy={904.37}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1302.24}
            cy={908.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1310.02}
            cy={912.72}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1318.02}
            cy={916.24}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1326.2}
            cy={919.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1334.55}
            cy={921.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1343.05}
            cy={923.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1348.39}
            cy={925.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1353.75}
            cy={925.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1359.14}
            cy={926.5}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1364.54}
            cy={926.95}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1369.96}
            cy={927.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1375.38}
            cy={927.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1380.8}
            cy={927.14}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1386.22}
            cy={926.83}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1391.64}
            cy={926.33}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1398.65}
            cy={925.41}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1405.64}
            cy={924.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1412.57}
            cy={922.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1419.43}
            cy={920.83}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1426.21}
            cy={918.71}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1432.9}
            cy={916.31}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1439.47}
            cy={913.62}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1445.92}
            cy={910.65}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1452.22}
            cy={907.42}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1458.4}
            cy={903.9}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1464.4}
            cy={900.13}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1470.23}
            cy={896.11}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1475.87}
            cy={891.83}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1481.31}
            cy={887.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1486.53}
            cy={882.52}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1491.53}
            cy={877.51}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1496.29}
            cy={872.26}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={1500.8}
            cy={866.78}
            r={49.78}
          />
        </g>
        <g id="back_svg__F">
          <circle
            className="back_svg__circle"
            cx={221.3}
            cy={322.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={224.16}
            cy={322.36}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={235.62}
            cy={320.79}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={247.11}
            cy={319.84}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={258.63}
            cy={319.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={270.18}
            cy={319.51}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={281.75} cy={320} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={293.33}
            cy={320.84}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={304.92}
            cy={321.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={316.51}
            cy={323.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={328.11}
            cy={324.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={339.69}
            cy={326.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={351.27}
            cy={327.84}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={362.83}
            cy={329.32}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={372.57}
            cy={330.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={380.55}
            cy={331.3}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={388.58} cy={332} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={396.64}
            cy={332.56}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={404.72}
            cy={332.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={412.8}
            cy={333.18}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={420.88}
            cy={333.2}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={428.93} cy={333} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={436.95}
            cy={332.56}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={444.91}
            cy={331.87}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={452.82}
            cy={330.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={460.65}
            cy={329.61}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={468.38}
            cy={328.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={477.35}
            cy={325.72}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={486.59}
            cy={322.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={495.61}
            cy={319.22}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={504.41}
            cy={315.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={512.95}
            cy={310.23}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={521.16}
            cy={304.56}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={528.81}
            cy={298.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={535.85}
            cy={290.83}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={542.22}
            cy={282.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={547.85}
            cy={274.56}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={552.68}
            cy={265.72}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={556.65}
            cy={256.55}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={559.28}
            cy={248.62}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={561.72}
            cy={237.82}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={562.74}
            cy={228.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={562.73}
            cy={219.17}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={561.6} cy={210} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={559.32}
            cy={201.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={555.81}
            cy={192.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={551.03}
            cy={184.21}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={545.1}
            cy={176.73}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={538.27}
            cy={170.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={530.66}
            cy={164.83}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={522.4}
            cy={160.4}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={513.6}
            cy={156.96}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={504.34}
            cy={154.51}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={494.63}
            cy={153.04}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={484.75}
            cy={152.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={474.82}
            cy={153.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={464.99}
            cy={154.74}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={455.38}
            cy={157.31}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={446.11}
            cy={160.88}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={437.33}
            cy={165.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={429.18}
            cy={170.87}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={421.64}
            cy={176.99}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={414.71}
            cy={183.72}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={408.36}
            cy={191.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={402.6}
            cy={198.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={397.43}
            cy={207.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={392.82}
            cy={215.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={388.78}
            cy={224.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={385.31}
            cy={233.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={382.39}
            cy={243.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={380.02}
            cy={253.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={378.2}
            cy={262.75}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={376.92}
            cy={272.55}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={376.17}
            cy={282.33}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={375.87}
            cy={292.1}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={375.97}
            cy={301.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={376.45}
            cy={311.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={377.26}
            cy={321.32}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={378.08}
            cy={328.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={378.94}
            cy={335.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={379.92}
            cy={341.73}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={381} cy={348.25} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={382.18}
            cy={354.77}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={383.43}
            cy={361.27}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={384.77}
            cy={367.77}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={386.16}
            cy={374.25}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={387.61}
            cy={380.72}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={389.09}
            cy={387.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={390.61}
            cy={393.64}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={392.15}
            cy={400.08}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={393.69}
            cy={406.51}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={396.73}
            cy={419.1}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={399.76}
            cy={431.7}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={402.8}
            cy={444.3}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={405.83}
            cy={456.89}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={408.87}
            cy={469.49}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={411.9}
            cy={482.08}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={414.94}
            cy={494.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={417.98}
            cy={507.28}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={421.01}
            cy={519.87}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={424.05}
            cy={532.47}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={427.08}
            cy={545.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={430.12}
            cy={557.66}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={432.97}
            cy={569.48}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={435.26}
            cy={578.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={437.55}
            cy={588.49}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={439.84}
            cy={597.99}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={442.13}
            cy={607.49}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={444.42}
            cy={616.99}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={446.71}
            cy={626.49}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={449} cy={636} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={451.29}
            cy={645.5}
            r={49.78}
          />
          <circle className="back_svg__circle" cx={453.58} cy={655} r={49.78} />
          <circle
            className="back_svg__circle"
            cx={455.87}
            cy={664.5}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={458.16}
            cy={674.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={460.45}
            cy={683.51}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={462.51}
            cy={692.07}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={464.34}
            cy={699.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={466.18}
            cy={707.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={468.01}
            cy={714.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={469.85}
            cy={722.52}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={471.68}
            cy={730.13}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={473.52}
            cy={737.75}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={475.35}
            cy={745.36}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={477.19}
            cy={752.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={479.02}
            cy={760.59}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={480.86}
            cy={768.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={482.69}
            cy={775.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={484.53}
            cy={783.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={487.07}
            cy={794.07}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={489.78}
            cy={805.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={492.37}
            cy={817.78}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={494.8}
            cy={829.81}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={497.01}
            cy={841.9}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={498.97}
            cy={854.04}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={500.61}
            cy={866.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={501.89}
            cy={878.32}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={502.77}
            cy={890.42}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={503.19}
            cy={902.43}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={503.11}
            cy={914.35}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={502.47}
            cy={926.13}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={501.54}
            cy={935.42}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={500.31}
            cy={943.95}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={499.18}
            cy={950.09}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={497.85}
            cy={956.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={496.31}
            cy={962.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={494.55}
            cy={968.09}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={492.57}
            cy={973.94}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={490.35}
            cy={979.7}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={487.89}
            cy={985.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={485.17}
            cy={990.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={482.21}
            cy={996.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={478.98}
            cy={1001.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={475.47}
            cy={1007.14}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={470.18}
            cy={1014.24}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={459.43}
            cy={1026.15}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={447.45}
            cy={1036.59}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={434.39}
            cy={1045.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={420.39}
            cy={1053.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={405.61}
            cy={1059.41}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={390.18}
            cy={1064.26}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={374.27}
            cy={1067.79}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={358.01}
            cy={1070.02}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={341.55}
            cy={1070.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={325.03}
            cy={1070.69}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={308.61}
            cy={1069.18}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={292.43}
            cy={1066.48}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={281.35}
            cy={1063.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={275.14}
            cy={1062.23}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={268.98}
            cy={1060.41}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={262.87}
            cy={1058.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={256.81}
            cy={1056.38}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={250.79}
            cy={1054.18}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={244.83}
            cy={1051.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={238.91}
            cy={1049.41}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={233.04}
            cy={1046.86}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={227.2}
            cy={1044.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={221.41}
            cy={1041.44}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={215.66}
            cy={1038.58}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={209.95}
            cy={1035.63}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={202.07}
            cy={1031.39}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={193.54}
            cy={1026.57}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={185.08}
            cy={1021.58}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={176.69}
            cy={1016.44}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={168.37}
            cy={1011.16}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={160.12}
            cy={1005.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={151.92}
            cy={1000.26}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={143.78}
            cy={994.67}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={135.69}
            cy={989.01}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={127.64}
            cy={983.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={119.63}
            cy={977.54}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={111.65}
            cy={971.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={103.71}
            cy={965.99}
            r={49.78}
          />
					</g>
					<g id="back_svg__f-stroke">
          <circle
            className="back_svg__circle"
            cx={611.05}
            cy={490.82}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={603.61}
            cy={500.51}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={595.87}
            cy={509.91}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={587.79}
            cy={519.05}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={579.43}
            cy={527.9}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={570.79}
            cy={536.46}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={561.87}
            cy={544.73}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={552.68}
            cy={552.71}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={543.24}
            cy={560.4}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={533.55}
            cy={567.78}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={523.62}
            cy={574.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={513.43}
            cy={581.64}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={503.12}
            cy={588.06}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={492.56}
            cy={594.18}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={481.81}
            cy={599.98}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={470.89}
            cy={605.45}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={459.8}
            cy={610.57}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={448.55}
            cy={615.36}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={437.17}
            cy={619.8}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={425.65}
            cy={623.88}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={414.06}
            cy={627.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={402.29}
            cy={630.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={390.46}
            cy={633.97}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={378.55}
            cy={636.6}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={366.57}
            cy={638.85}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={354.53}
            cy={640.72}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={342.45}
            cy={642.2}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={330.33}
            cy={643.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={318.18}
            cy={643.99}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={306.02}
            cy={644.29}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={293.85}
            cy={644.19}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={281.68}
            cy={643.68}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={269.52}
            cy={642.76}
            r={49.78}
          />
          <circle
            className="back_svg__circle"
            cx={257.39}
            cy={641.41}
            r={49.78}
          />
        </g>
      </g>
      <g id="back_svg__frei">
        <g id="back_svg__black-star4">
          <path
            className="back_svg__black-star"
            d="M1009.95 165.86l-76.18-76.19M1025.69 127.77H918.03M1009.95 89.67l-76.18 76.19M971.86 16.33v217.52"
          />
        </g>
        <g id="back_svg__black-star3">
          <path
            className="back_svg__black-star"
            d="M114.89 176.91L38.7 100.73M130.63 138.82H22.96M114.89 100.73L38.7 176.91M76.8 27.38v217.53"
          />
        </g>
        <g id="back_svg__black-star2">
          <path
            className="back_svg__black-star"
            d="M200 1674.74l-76.18-76.18M215.74 1636.65H108.08M200 1598.56l-76.18 76.18M161.91 1525.21v217.53"
          />
        </g>
        <g id="back_svg__black-star1">
          <path
            className="back_svg__black-star"
            d="M1874.02 997.29l-76.18-76.18M1889.76 959.2H1782.1M1874.02 921.11l-76.18 76.18M1835.93 847.76v217.53"
          />
        </g>
        <g id="back_svg__black-star">
          <path
            className="back_svg__black-star"
            d="M1856.29 1623.06l-76.18-76.18M1872.03 1584.97h-107.66M1856.29 1546.88l-76.18 76.18M1818.2 1473.53v217.53"
          />
        </g>
        <g id="back_svg__lila-star">
          <path
            fill="#fff"
            strokeWidth={3.15}
            stroke="#231f20"
            d="M1434 1556.16a12.1 12.1 0 01-10.42-18.49l84.19-135.1a12.12 12.12 0 0110.1-5.7h0a12.12 12.12 0 0110.25 5.42l32.25 48.7 74.39-119.36a12.09 12.09 0 0120.48-.52l32.26 48.7 74.5-119.57a12.1 12.1 0 0120.54 12.79l-84.19 135.1a12.11 12.11 0 01-12.71 5.45l-.69-.14a12.14 12.14 0 01-7.64-5.17l-31.84-48.09-74.25 119.13a12.1 12.1 0 01-12.69 5.45l-.69-.14a12.07 12.07 0 01-7.65-5.17l-31.86-48.11-74.23 119.12a12.09 12.09 0 01-10.1 5.7z"
          />
          <path
            fill="#c581ff"
            stroke="#231f20"
            strokeWidth={3.15}
            className="back_svg__cls-4330"
            d="M1834.98 1119.33l-12.58 98.8 90.07 42.5-97.85 18.56-12.59 98.8-47.89-87.33-97.85 18.56 68.26-72.53-47.89-87.33 90.07 42.5 68.25-72.53z"
          />
        </g>
        <g id="back_svg__red-star">
          <path
            fill="#fff"
            strokeWidth={3.15}
            stroke="#231f20"
            d="M439.78 2347.76a7.13 7.13 0 01-7.51-3.16l-64.38-94.47-27.66 87.19a6.89 6.89 0 01-5.42 4.88 7.15 7.15 0 01-6.78-2.95l-91.11-121-21.44 80.36a7 7 0 01-5 5.13h-.09a7 7 0 01-6.86-2.45L119 2202.82a8.34 8.34 0 01.1-11.06 6.76 6.76 0 0110.12.62l75.87 88.45 21.73-81.41a6.86 6.86 0 015.36-5.21 7.13 7.13 0 016.95 2.91l91.58 121.68 27.91-88a6.9 6.9 0 015.6-4.91 7.23 7.23 0 016.83 3.29l72.52 106.4c2.41 3.54 1.83 8.42-1.29 10.9a6.43 6.43 0 01-2.5 1.28z"
          />
          <path
            fill="#eb1d25"
            stroke="#231f20"
            strokeWidth={3.15}
            className="back_svg__cls-4332"
            d="M40.73 2114.18l61.1 32.32 49.62-48.12-11.86 68.09 61.1 32.33-68.43 9.76-11.85 68.1-30.44-62.06-68.43 9.76 49.62-48.12-30.43-62.06z"
          />
        </g>
      </g>
    </svg>
  );
})

export default SvgBack;

